import { SVGProps } from 'react';

const Automation = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M9.732 5.38a.75.75 0 0 1 .844 1.24c-.74.504-1.47 1.104-2.161 1.795-1.814 1.814-2.989 3.874-3.447 5.707-.463 1.85-.174 3.33.703 4.206.86.86 2.296 1.154 4.096.73 1.433-.337 3.014-1.118 4.511-2.308H12a.75.75 0 0 1 0-1.5h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-2.106c-1.658 1.325-3.45 2.227-5.14 2.625-2.075.488-4.132.237-5.5-1.13-1.395-1.396-1.628-3.51-1.097-5.631.535-2.139 1.868-4.43 3.841-6.404A16.5 16.5 0 0 1 9.732 5.38m8.595-.769a.75.75 0 0 1 1.06 0c1.625 1.623 1.678 4.204.776 6.687a.75.75 0 0 1-1.41-.513c.817-2.248.594-4.095-.425-5.113a.75.75 0 0 1 0-1.06M14 1.25a.75.75 0 0 1 .75.75A1.25 1.25 0 0 0 16 3.25a.75.75 0 0 1 0 1.5A1.25 1.25 0 0 0 14.75 6a.75.75 0 0 1-1.5 0A1.25 1.25 0 0 0 12 4.75a.75.75 0 0 1 0-1.5A1.25 1.25 0 0 0 13.25 2a.75.75 0 0 1 .75-.75"
    />
  </svg>
);

export default Automation;
